import React from "react";
import { Target, CalendarDays, Fingerprint, Globe, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Communication stratégique",
  description: "Conseil et planification sur mesure pour bâtir une image de marque forte et pérenne auprès de vos cibles.",
  icon: Target,
  href: "/ExpertisePage"
}, {
  title: "Événementiel professionnel",
  description: "Organisation rigoureuse et créative de vos événements corporate et institutionnels de haute envergure.",
  icon: CalendarDays,
  href: "/ExpertisePage"
}, {
  title: "Branding",
  description: "Création d'identités visuelles mémorables qui incarnent vos valeurs et votre vision avec précision.",
  icon: Fingerprint,
  href: "/ExpertisePage"
}, {
  title: "Communication digitale B2B",
  description: "Stratégies digitales ciblées pour engager efficacement vos partenaires et clients décisionnels.",
  icon: Globe,
  href: "/ExpertisePage"
}];
export default function PiliersDexpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="60191" id="domaines-dintervention" ref={ref} className="py-24 bg-background relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className={cn("mb-16 text-center max-w-3xl mx-auto transition-all duration-700 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-foreground mb-6 tracking-tighter">
            Domaines d'Intervention
          </h2>
          <p className="text-lg font-sans text-muted-foreground leading-relaxed">
            Une expertise multidimensionnelle structurée pour répondre aux exigences de crédibilité et d'influence des organisations modernes au Burkina Faso.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => <div key={index} data-index={index} className={cn("transition-all duration-700 delay-[100ms]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")} style={{
          transitionDelay: `${index * 100}ms`
        }}>
              <Link to={service.href} className="block h-full">
                <Card className="group h-full border-border/10 bg-card/50 backdrop-blur-xl hover:bg-primary transition-all duration-500 hover:shadow-[0_0_30px_rgba(212,28,61,0.15)] hover:-translate-y-2 cursor-pointer overflow-hidden relative rounded-lg">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex items-center justify-center size-14 rounded-lg bg-secondary/10 text-secondary group-hover:bg-primary-foreground group-hover:text-primary transition-colors duration-300">
                      <service.icon strokeWidth={2} className="size-7 group-hover:scale-110 transition-transform duration-300" />
                    </div>
                    <CardTitle className="text-xl font-serif font-bold text-foreground group-hover:text-primary-foreground transition-colors duration-300">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="grow">
                    <CardDescription className="text-muted-foreground font-sans group-hover:text-primary-foreground/90 transition-colors duration-300 text-base leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter className="pt-4">
                    <div className="flex items-center text-xs font-mono uppercase tracking-widest text-primary group-hover:text-primary-foreground transition-colors duration-300">
                      Découvrir l'expertise
                      <ChevronRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </div>
                  </CardFooter>
                </Card>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}